import {lazy} from '@aboutyou/lazy-imports';

export const ConditionalUspBanner = lazy(() =>
  import('./ConditionalUspBanner.eager').then(mod => ({
    default: mod.ConditionalUspBanner,
  })),
);
